/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var Shopify = Shopify || {};
var moneyFormat = '${{amount}}';
Shopify.formatMoney = function(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters(
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function quickShop(productId) {
  const root = ReactDOM.createRoot(document.getElementById('sku-drawer'))
  const drawer = React.createElement(HXZDrawer, {pId: productId, onClose: () => {root.unmount(); document.body.removeAttribute('style')}}, null)
  document.body.style.overflow = 'hidden'
  root.render(drawer)
}

function addToCart(data, btnDom) {
  if (btnDom) {
    btnDom.setAttribute('disabled', 'disabled');
  }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify({
      items: data
    })
  }).then(() => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'))
    document.querySelector('a[href="/cart"]')?.click()
    if (btnDom) {
      btnDom.removeAttribute('disabled');
    }
  })
}

const bundleZengpin = [
  {productId: 7021428900022, zengpinId: 7580703228086, zengpinVariant: 42178178941110},
  {productId: 7563434819766, zengpinId: 7564972196022, zengpinVariant: 42129193599158},
  {productId: 7558712590518, zengpinId: 7559873364150, zengpinVariant: 42112855572662},
  {productId: 7558709018806, zengpinId: 7559872938166, zengpinVariant: 42112846299318},
  {productId: 7540328038582, zengpinId: 7585293205686, zengpinVariant: 42206092198070},
  {productId: 7021432307894, zengpinId: 7585294385334, zengpinVariant: 42206096621750},
  {productId: 7525194498230, zengpinId: 7525601018038, zengpinVariant: 42004647444662},
  {productId: 7021434536118, zengpinId: 7455946014902, zengpinVariant: 41759371722934},
  {productId: 7173522718902, zengpinId: 7455957483702, zengpinVariant: 41759420711094},
  {productId: 7171400302774, zengpinId: 7455971967158, zengpinVariant: 41759465898166},
  {productId: 7021426966710, zengpinId: 7455959351478, zengpinVariant: 41759428804790},
  {productId: 7021426540726, zengpinId: 7455961317558, zengpinVariant: 41759436865718},
  {productId: 7115578704054, zengpinId: 7455972589750, zengpinVariant: 41759466684598},
  {productId: 7295015518390, zengpinId: 7580699164854, zengpinVariant: 42178169077942},
  {productId: 7341913866422, zengpinId: 7455954043062, zengpinVariant: 41759406260406},
  {productId: 7115611963574, zengpinId: 7455963578550, zengpinVariant: 41759444762806},
  {productId: 7165665968310, zengpinId: 7455968460982, zengpinVariant: 41759458558134},
]
const oldZengpinList = [7547694121142, 7455975997622, 7455974195382, 7580695003318, 7576471273654, 7438684815542, 7485199909046, 7462231998646, 7505020813494, 7505023991990, 7505023697078, 7540323221686, 7455974195382, 7455974883510, 7505015013558, 7505014489270, 7505019994294, 7505013309622, 7505023238326, 7505023041718, 7505019076790, 7505011867830] 

function isCartEqual(oldC, newC) {
  if (oldC.length !== newC.length) return false
  let flag = true
  for (let i = 0, j = newC.length; i < j; i++) {
    let isMutiple = oldC.filter(item => item.id === newC[i].id); // 刻字等产品可能存在多个，忽略
    if (isMutiple.length > 1) continue
    let inOld = oldC.find(item => item.id === newC[i].id)
    if (!inOld) {
      flag = false
      break
    }
    if (inOld.quantity !== newC[i].quantity) {
      flag = false
      break
    }
  }
  return flag
}

window.moneyFormat = function(price) {
  return `${window.currencies[window.theme.currency]}${price.toLocaleString("ja-JP")} ${window.theme.currency}`
}

function checkZengpinPair() {
  fetch(`${window.location.origin}/cart.js`, {
    method: 'get', 
    headers: {'content-type': 'application/json',},
  }).then(r => r.json()).then(async(r) => {
    let cartItems = r.items
    let oldCartItems = []
    let newCartItem = []
    for (let i = 0, j = cartItems.length; i < j; i++) {
      oldCartItems.push({id: cartItems[i].variant_id, quantity: cartItems[i].quantity})
      let bItem = bundleZengpin.find(p => p.productId === cartItems[i].product_id)

      if (bItem) {
        newCartItem.push({id: cartItems[i].variant_id, quantity: cartItems[i].quantity, properties: cartItems[i].properties})
        let newBundleZengpin = newCartItem.find(p => p.id === bItem.zengpinVariant)
        if (newBundleZengpin) {
          newBundleZengpin.quantity = cartItems[i].quantity + newBundleZengpin.quantity
        } else {
          newCartItem.push({id: bItem.zengpinVariant, quantity: cartItems[i].quantity})
        }
        continue
      }
      let zItem = bundleZengpin.find(p => p.zengpinId === cartItems[i].product_id)
      if (zItem) continue
      let oldZengpin = oldZengpinList.find(p => p === cartItems[i].product_id)
      if (oldZengpin) continue   
      newCartItem.push({id: cartItems[i].variant_id, quantity: cartItems[i].quantity, properties: cartItems[i].properties})
    }

    if (isCartEqual(oldCartItems, newCartItem)) {
    } else {
        fetch(`${window.location.origin}/cart/clear.js`, {
          method: 'post',
        }).then(r => r.json()).then(r => {
          if (newCartItem.length === 0) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'))
            return
          }
          fetch(`${window.location.origin}/cart/add.js`, {
            method: 'post', 
            headers: {'content-type': 'application/json',},
            body: JSON.stringify({
              items: newCartItem.reverse()
            })
          }).then(r => r.json()).then(r => {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'))
          });
        }); 
    }
  })
}

(function(ns, fetch) {
  if (typeof fetch !== 'function') return;

  ns.fetch = function() {
    const response = fetch.apply(this, arguments);
    response.then(res => {
      if ([
        `${window.location.origin}/cart/add.js`,
        `${window.location.origin}/cart/update.js`,
        `${window.location.origin}/cart/change.js`,
        // `${window.location.origin}/cart/clear.js`,
      ].includes(res.url)) {
        res.clone().json().then(data => {
          checkZengpinPair()
        });
      }
    })
    return response;
  }
  checkZengpinPair()

}(window, window.fetch))

function bindAddToCart() {
  const addToCartBtns = document.querySelectorAll('.hxz-cart-btn')

  for (let btn of addToCartBtns) {
    const item = btn.closest('.s-product')
    const button = btn.querySelector('button')
    if (button) {
    button.addEventListener('click', () => {
      if (item.dataset.multiple !== '1') {
        const toCart = [
          {
            quantity: 1,
            id: item.dataset.skuId,
          }
        ]
        const match = button.getAttribute('data-match-id')

        if (match) {
          toCart.unshift({
            quantity: 1,
            id: match,
          })
        }
        addToCart(toCart, button)
        return
      }
      quickShop(item.dataset.productId)
    })
  }
  }
}

function callService() {
  document.getElementById('launcher').contentDocument.querySelector('button').click()
}

(function() {
  const repeatBgMap = {
    1: 'https://cdn.shopify.com/s/files/1/0528/2486/7015/files/landing-repeat-bg.png?v=1669959877',
    2: 'https://cdn.shopify.com/s/files/1/0598/5396/3446/files/newlife-pink.jpg?v=1678419841'
  }
  bindAddToCart()
  const urlParams = new URLSearchParams(window.location.search)
  const myParam = urlParams.get('openCart')
  if (myParam && myParam === '1') {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'))
    document.querySelector('a[href="/cart"]')?.click()
  }
  if (location.pathname === '/pages/2023-happybag') {
    document.getElementById('main').style.backgroundImage = `url(${repeatBgMap[1]})`
  }
  if (location.pathname === '/pages/2023-new-life') {
    document.getElementById('main').style.backgroundImage = `url(${repeatBgMap[2]})`
  }
  if (location.pathname === '/pages/morthers-day-2023') {
    document.getElementById('main').style.backgroundImage = `url(https://cdn.shopify.com/s/files/1/0528/2486/7015/files/mothersday-bg.webp?v=1682076171)`
  }

  window.addEventListener('scroll', () => {
    
    if (window.innerWidth < 640 && location.pathname.startsWith('/products')) return
    if (document.documentElement.scrollTop + window.innerHeight >= document.getElementById('shopify-section-footer').offsetTop ) {
      document.querySelector('.hxz-service-bar').classList.remove('sticky')
    } else {
      document.querySelector('.hxz-service-bar').classList.add('sticky')
    }
  })
}())

